

export default {
    kategoriSOSList: [],
    subKategoriSOSList: [],
    syaratList: [],
    syaratKumpuls: [],
    totalRecords: 0,
    totalFiltered: 0,
    totalKatRecords: 0,
    totalSubKatRecords: 0,
    totalSyaratRecords: 0
}
